const nnTranslations = {
    laanerammeTekst: {
        boliglaanKalkulator: 'Bustadlånskalkulator',
        hvorMyeKanJegLaane: 'Kor mykje kan eg låne?',
        hvaKosterLaanet: 'Kva kostar lånet?',
        antallLaantakere: 'Tal på låntakarar',
        antallBarn: 'Tal på barn under 18 år',
        antallBiler: 'Tal på bilar',
        ingen: 'Ingen',
        samletAarsinntektFoerSkatt: 'Samla årsinntekt før skatt',
        samletGjeld: 'Samla gjeld',
        samletGjeldSublabel: 'Du treng ikkje føre opp gjeld som blir innfridd ved utbetaling av nytt bustadlån.',
        laanerammeSpoersmaal: 'Fyll ut felta for å sjå kor mykje vi trur du kan låne.',
        laanerammeSvar: 'Vi trur du kan låne',
        laanerammeSvarIkkeLaan: 'Basert på dei valde verdiane ser det ikkje ut til at vi kan tilby lån.',
        laanerammeFeilmelding: 'Vi klarer ikkje å hente kor mykje du kan låne, prøv igjen seinare.',
        soekBoliglaan: 'Søk bustadlån',
    },
    laanekostnadTekst: {
        annen: 'Annan',
        aar: 'år',
        maanedligKostnad: 'Månadleg kostnad',
        nedbetalingstid: 'Nedbetalingstid',
        nedbetalingstidRequired: 'Ver venleg og fyll ut dette feltet',
        nedbetalingstidError: 'Nedbetalingstid må vere mindre enn eller lik 30 år',
        oensketLaanebeloep: 'Ønsket lånebeløp',
        oensketNedbetalingstid: 'Ønsket nedbetalingstid',
        rentePaaLaanet: 'Rente på lånet',
        rentePaaLaanetSubLabel: 'Økonomien din må tole ei renteauke på minimum 3%',
        renteTilbakestill: 'Tilbakestill rente',
        vent: 'Vent...',
    },
    nedbetalingsplanTekst: {
        nedbetalingsplan: 'Nedbetalingsplan',
        lukk: 'Lukk',
        lukkNedbetalingsplan: 'Lukk nedbetalingsplan',
        visNedbetalingsplan: 'Vis nedbetalingsplan',
        aar: 'År',
        aaBetale: 'Å betale',
        avdrag: 'Avdrag',
        renterOgGebyr: 'Renter og gebyr',
        restgjeld: 'Restgjeld',
    },
    ok: 'Ok',
};
export default nnTranslations;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm5UcmFuc2xhdGlvbnMtY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RyYW5zbGF0aW9ucy9ublRyYW5zbGF0aW9ucy1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxjQUFjLEdBQTJCO0lBQzNDLGVBQWUsRUFBRTtRQUNiLG1CQUFtQixFQUFFLHNCQUFzQjtRQUMzQyxrQkFBa0IsRUFBRSx3QkFBd0I7UUFDNUMsZUFBZSxFQUFFLG1CQUFtQjtRQUNwQyxnQkFBZ0IsRUFBRSxtQkFBbUI7UUFDckMsVUFBVSxFQUFFLHlCQUF5QjtRQUNyQyxXQUFXLEVBQUUsY0FBYztRQUMzQixLQUFLLEVBQUUsT0FBTztRQUNkLDBCQUEwQixFQUFFLDRCQUE0QjtRQUN4RCxXQUFXLEVBQUUsYUFBYTtRQUMxQixtQkFBbUIsRUFBRSxtRkFBbUY7UUFDeEcsb0JBQW9CLEVBQUUsd0RBQXdEO1FBQzlFLGNBQWMsRUFBRSxxQkFBcUI7UUFDckMsc0JBQXNCLEVBQUUsd0VBQXdFO1FBQ2hHLHFCQUFxQixFQUFFLG9FQUFvRTtRQUMzRixhQUFhLEVBQUUsZUFBZTtLQUNqQztJQUNELGlCQUFpQixFQUFFO1FBQ2YsS0FBSyxFQUFFLE9BQU87UUFDZCxHQUFHLEVBQUUsSUFBSTtRQUNULGdCQUFnQixFQUFFLGtCQUFrQjtRQUNwQyxlQUFlLEVBQUUsaUJBQWlCO1FBQ2xDLHVCQUF1QixFQUFFLG9DQUFvQztRQUM3RCxvQkFBb0IsRUFBRSxvREFBb0Q7UUFDMUUsa0JBQWtCLEVBQUUsa0JBQWtCO1FBQ3RDLHNCQUFzQixFQUFFLHdCQUF3QjtRQUNoRCxjQUFjLEVBQUUsZ0JBQWdCO1FBQ2hDLHNCQUFzQixFQUFFLGtEQUFrRDtRQUMxRSxpQkFBaUIsRUFBRSxvQkFBb0I7UUFDdkMsSUFBSSxFQUFFLFNBQVM7S0FDbEI7SUFDRCxxQkFBcUIsRUFBRTtRQUNuQixnQkFBZ0IsRUFBRSxrQkFBa0I7UUFDcEMsSUFBSSxFQUFFLE1BQU07UUFDWixvQkFBb0IsRUFBRSx1QkFBdUI7UUFDN0MsbUJBQW1CLEVBQUUsc0JBQXNCO1FBQzNDLEdBQUcsRUFBRSxJQUFJO1FBQ1QsUUFBUSxFQUFFLFVBQVU7UUFDcEIsTUFBTSxFQUFFLFFBQVE7UUFDaEIsYUFBYSxFQUFFLGlCQUFpQjtRQUNoQyxTQUFTLEVBQUUsV0FBVztLQUN6QjtJQUNELEVBQUUsRUFBRSxJQUFJO0NBQ1gsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=